import { render, staticRenderFns } from "./editpeserta.vue?vue&type=template&id=07cbbc58&"
import script from "./editpeserta.vue?vue&type=script&lang=js&"
export * from "./editpeserta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports